// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/form-item-tradesmen/form-item-tradesmen.component.scss
// module id = 1100
// module chunks = 0